import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "../utils/motion";
import ScrollAnimation from "../components/ScrollAnimation";
import { preloadImagesWithPriority } from "../utils/imagePreloader";
import { useNavigate } from "react-router-dom";

/* ================== ENV CONSTANTS ================== */
const GITHUB_USERNAME = process.env.REACT_APP_GITHUB_USERNAME;
const REPO_NAME = process.env.REACT_APP_GITHUB_REPO;
const BRANCH = process.env.REACT_APP_GITHUB_BRANCH;
const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN;

/* ================== AXIOS INSTANCE ================== */
const githubApi = axios.create({
  baseURL: "https://api.github.com",
  headers: {
    Authorization: `Bearer ${GITHUB_TOKEN}`,
    Accept: "application/vnd.github+json",
  },
});

export default function ViewAllClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const folderRes = await githubApi.get(
          `/repos/${GITHUB_USERNAME}/${REPO_NAME}/contents/clients`
        );

        const folders = folderRes.data.filter(i => i.type === "dir");

        const clientData = await Promise.all(
          folders.map(async (folder) => {
            try {
              const res = await githubApi.get(
                `/repos/${GITHUB_USERNAME}/${REPO_NAME}/contents/clients/${folder.name}/${folder.name}.json`
              );

              const data = JSON.parse(atob(res.data.content));

              return {
                clientId: data.clientId,
                displayName: data.client,
                coverImage: `https://raw.githubusercontent.com/${GITHUB_USERNAME}/${REPO_NAME}/${BRANCH}/${data.coverImage}`,
                events: data.events || [],
              };
            } catch {
              return null;
            }
          })
        );

        const validClients = clientData.filter(Boolean);
        setClients(validClients);

        preloadImagesWithPriority(
          validClients.slice(0, 6).map(c => c.coverImage)
        ).catch(() => null);

      } catch (err) {
        console.error("Failed to fetch clients:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  if (loading) {
    return <div className="text-center py-20">Loading...</div>;
  }

  return (
    <section className="px-4 md:px-12 py-14">
      <div className="max-w-6xl mx-auto">
        <h1 className="section-heading text-center mb-10">
          All Clients
        </h1>

       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
  {clients.map((client) => (
    <div
      key={client.clientId}
      whileHover={{ scale: 1.03 }}
      className="cursor-pointer rounded-2xl overflow-hidden border border-white/10 bg-white/[0.02]"
      onClick={() => navigate(`/clients/${client.clientId}`)}
    >
      <img
        src={client.coverImage}
        alt={client.displayName}
        className="h-64 w-full object-cover"
        loading="lazy"
      />

      <div className="p-5">
        {/* 👇 Force page reload only on name click */}
        <h3
          className="text-white text-xl hover:underline"
          onClick={(e) => {
            e.stopPropagation(); // stop card click
            window.location.href = `/clients/${client.clientId}`;
          }}
        >
          {client.displayName}
        </h3>
      </div>
    </div>
  ))}
</div>

      </div>
    </section>
  );
}
